module.exports = __webpack_public_path__ + "media/alarm.18428ba9.mp3";